import { FC } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import TextField from '@app/components/input/TextField';

import messages from '../Address.messages';
import { AddressFormFields } from '../Address.constants';
import ValidationMessage from '../ValidationMessage/ValidationMessage';

export const PhoneField: FC<{ namespace: string }> = ({ namespace }) => {
  const { errors } = useFormContext();

  return (
    <Controller
      name={`${namespace}.${AddressFormFields.Phone}`}
      defaultValue=""
      render={({ ref, ...props }) => (
        <TextField
          autoComplete="tel"
          data-testid="address-phone-field"
          maxLength={40}
          isValid={!errors[namespace]?.[AddressFormFields.Phone]}
          formLabel={<FormattedMessage {...messages.phone} />}
          innerRef={ref}
          type="tel"
          {...props}
        />
      )}
      rules={{
        required: {
          //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
          message: <ValidationMessage type="required" fieldNameKey="phone" />,
          value: true,
        },
        pattern: {
          //  @ts-expect-error: TS only support string, not ReactElement (react-hook-form.com/api#register)
          message: <ValidationMessage type="invalid" fieldNameKey="phone" />,
          // Using same rule than old shop for consistency
          value: /^[^\p{L}\p{C}]*$/u,
        },
      }}
    />
  );
};
